var supara_token = "";
var coupon_code = "";
var reward_name = "";
var settings = {
  url: "https://api.backend.gw.t.int.suparagroup.com/gq-connect/auth/token",
  method: "POST",
  timeout: 0,
  headers: {
    "Content-Type": "application/json",
  },
  data: JSON.stringify({
    api_key: "98931F7B-B67D-492C-96F1-A50D66C4DA1B",
    client: "magenest",
  }),
};
var test = [];

$.ajax(settings).done(function (response) {
  supara_token = response.data.token;
});
function confirmRedeemedPopup(cus_phone, id) {
  var ajax_reward_redeem = {
    url: "https://api.backend.gw.t.int.suparagroup.com/gq-connect/customers/issue/rewards",
    method: "POST",
    timeout: 0,
    headers: {
      Authorization: "Bearer " + supara_token,
      "Content-Type": "application/json",
    },
    data: JSON.stringify({
      mobile: parseInt(cus_phone),
      trx_number: "",
      note: reward_name,
      rewards: {
        id: id,
        quantity: 1,
      },
    }),
  };
  $.ajax(ajax_reward_redeem)
    .done(function (reward_detail) {
      try {
        if (reward_detail.data.status.success == true) {
          $(".popup-redeemed-title,.redeemed-btn-div").removeClass("hidden");
          $(".redeemed-btn-div").css("display", "inline-grid");
          $(".popup-title,.popup-text,.confirm-redeem-btn-div").addClass(
            "hidden"
          );
          var button = document.getElementById("use-now");
          coupon_code = reward_detail.data.intouch.couponCode;
          button.setAttribute("onclick", "userItNow(" + coupon_code + ")");
        }
      } catch {
        if ("error" in reward_detail) {
          alert(reward_detail.error);
        } else if (reward_detail.data.message.includes("already redeemed")) {
          alert(reward_detail.data.message);
        } else {
          alert("Something went wrong!");
        }
      }
    })
    .fail(function (error) {
      alert(error.responseJSON.error);
    });
}

function userItNow(code) {
  const locale = window.Shopify.locale;
  if (locale != 'th'){
    window.location.href =
    "/" + locale + "/pages/membership-voucher-detail" + "?id=" + encodeURIComponent(code);
  }
  else{
    window.location.href = "/pages/membership-voucher-detail" + "?id=" + encodeURIComponent(code);
  }
}

function noUseYet() {
  $(".popup-redeemed-title,.redeemed-btn-div").addClass("hidden");
  $(".redeemed-btn-div").css("display", "none");
  $(".popup-title,.popup-text,.confirm-redeem-btn-div").removeClass("hidden");
  $(".overlay,.modal").addClass("hidden");
}

function openPopup() {
  $(".overlay,.modal").removeClass("hidden");
}
function closePopup() {
  $(".overlay,.modal").addClass("hidden");
}

function faqs(index) {
  var acc = document.getElementsByClassName("faq-btn-div");
  acc[index].addEventListener("click", function () {
    this.classList.toggle("faq-active");
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}

function rewardDetailOnLoad(cus_phone, language_code = false) {
  let language_data = {
    "points_text": "Points",
    "expire_in": "Expire in",
    "point_left": " points remaining after redemption",
    "btn_redeem": "Redeem",
    "redemption_confirm": "Confirm Redemption",
    "redemption_success": "Your points have been used to redeem the reward!",
    "redemption_note1": "Would you like to use ",
    "redemption_note2": " points to redeem this reward?",
    "cancel": "Cancel",
    "confirm": "Confirm",
    "use_now": "Use now",
    "use_later": "Use later",
    "description": "Description",
    "term_codition": "Terms and Conditions"
  }
  if (language_code == "th") {
    language_data = {
        "points_text": "คะแนน",
        "expire_in": "หมดอายุใน",
        "point_left": " คะแนนคงเหลือหลังแลกรางวัล",
        "btn_redeem": "แลกของรางวัล",
        "redemption_confirm": "ยืนยันการแลกของรางวัล",
        "redemption_success": "คะแนนของคุณได้ถูกใช้ไปในการแลกของรางวัลสำเร็จ!",
        "redemption_note1": "คุณต้องการใช้ ",
        "redemption_note2": " คะแนนเพื่อแลกของรางวัลหรือไม่",
        "cancel": "ยกเลิก",
        "confirm": "ยืนยัน่",
        "use_now": "ใช้ทันที",
        "use_later": "ใช้ในภายหลัง",
        "description": "รายละเอียด",
        "term_codition": "ข้อกำหนดและเงื่อนไข"
    }
  }
  const current_url = new URLSearchParams(window.location.search);
  var id = current_url.get("id");
  var cus_point = 0;
  var ajax_customer = {
    url:
      "https://api.backend.gw.t.int.suparagroup.com/gq-connect/customers/get?mobile=" +
      parseInt(cus_phone) +
      "&source=INSTORE",
    method: "GET",
    timeout: 0,
    headers: {
      Authorization: "Bearer " + supara_token,
    },
  };

  $.ajax(ajax_customer).done(function (cus) {
    cus_point =
      cus.data.customers[0].points_summaries[0].total_available_points;
    var ajax_reward = {
      url:
        "https://api.backend.gw.t.int.suparagroup.com/gq-connect/customers/rewards?mobile=" +
        parseInt(cus_phone) +
        "&id=" +
        id,
      method: "GET",
      timeout: 0,
      headers: {
        Authorization: "Bearer " + supara_token,
      },
    };
    $.ajax(ajax_reward).done(function (response) {
      reward = response.data.rewards[0].reward;
      reward_name = reward.name;
      left_point = (
        parseInt(cus_point) - parseInt(reward.intouchPoints)
      ).toString();
      btn_disable = '';
      btn_disable_class = '';
      if (left_point < 0){
        if(language_code == "th"){
          language_data.point_left = "เพิ่ม " + Math.abs(left_point).toString() + " คะแนนเพื่อแลกของรางวัลนี้";
        } else{
          language_data.point_left = Math.abs(left_point).toString() + " more points to redeem this reward";
        }
        btn_disable = 'disabled'
        btn_disable_class = 'disable_redeem'
      }
      else{
        if(language_code == "th"){
          language_data.point_left = left_point.toString() + "  คะแนนคงเหลือหลังแลกรางวัล";
        } else{
          language_data.point_left = left_point.toString() + " points remaining after redemption";
        }
      }
      try {
        items_left_num =
          parseInt(reward.restrictions.rewardLevel[0].limit) -
          parseInt(reward.restrictions.rewardLevel[0].consumed);
        items_left = items_left_num.toString() + " Items left";
      } catch {
        items_left = "";
      }
      var categoryList = "";
      for (j = 0; j < reward.categoryList.length; j++) {
        categoryList =
          categoryList +
          "<div class='filter-item'>" +
          reward.categoryList[j].name +
          "</div>";
      }
      var reward_detail_html =
        '<div class="reward-img-div"><img class="reward-img" src="' +
        reward.imageUrl +
        '"><div class="reward-tag">' +
        reward.label +
        '</div></div><div class="reward-info-div"><div class="reward-title-div"><div class="reward-tile" id="reward-name">' +
        reward_name +
        '</div><div class="reward-remain">' +
        items_left +
        '</div></div><div class="reward-point-require-div"><img src="https://cdn.shopify.com/s/files/1/0631/7755/6173/files/GQ-Coin.png?v=1715157282" class="gqcoin_icon"><span class="reward-poin"> ' +
        reward.intouchPoints +
        ' </span>'+ language_data.points_text +'</div><div class="reward-expire">'+ language_data.expire_in +': ' +
        reward.endTime +
        '</div><div class="filter-line"><div class="store-tile">Store</div>' +
        categoryList +
        '</div><div class="redeem-btn-div"><div class="point-left">' +
        language_data.point_left +'</div><button onclick="openPopup()" class="redeem-btn ' +btn_disable_class+ '"' + btn_disable + '><svg className="redeem-gift-icon" id="gift-box-with-lace-svgrepo-com" xmlns="http://www.w3.org/2000/svg" width="13.873" height="14.185" viewBox="0 0 13.873 14.185"><g id="Group_5" data-name="Group 5"><path id="Path_4" data-name="Path 4" d="M16.5,3.181H13.314q.1-.084.2-.179a2.651,2.651,0,0,0,.749-1.349A1.4,1.4,0,0,0,13.928.365,1.3,1.3,0,0,0,12.982,0a2.5,2.5,0,0,0-1.691.782,2.951,2.951,0,0,0-.482.63,2.913,2.913,0,0,0-.479-.63A2.5,2.5,0,0,0,8.639,0a1.3,1.3,0,0,0-.946.365C7.071.988,7.255,2.146,8.111,3c.063.063.129.123.2.179H5.125A1.252,1.252,0,0,0,3.874,4.431v.326A1.252,1.252,0,0,0,5.125,6.008h.184v6.927a1.252,1.252,0,0,0,1.251,1.251h8.5a1.252,1.252,0,0,0,1.251-1.251V6.008H16.5a1.252,1.252,0,0,0,1.251-1.251V4.431A1.252,1.252,0,0,0,16.5,3.181ZM11.718,1.209A1.9,1.9,0,0,1,12.982.6.726.726,0,0,1,13.5.792a.816.816,0,0,1,.166.749,2.045,2.045,0,0,1-.583,1.034,1.9,1.9,0,0,1-1.264.606.726.726,0,0,1-.519-.189C10.93,2.622,11.121,1.805,11.718,1.209ZM8.537,2.575c-.6-.6-.787-1.413-.417-1.783A.726.726,0,0,1,8.639.6,1.9,1.9,0,0,1,9.9,1.209a2.044,2.044,0,0,1,.583,1.034.816.816,0,0,1-.166.749.726.726,0,0,1-.519.189A1.9,1.9,0,0,1,8.537,2.575Zm1,11.007H6.559a.648.648,0,0,1-.647-.647V6.008H9.536v7.574Zm0-8.177H5.125a.648.648,0,0,1-.647-.647V4.431a.648.648,0,0,1,.647-.647H9.536Zm1.946,8.177H10.139v-9.8h1.343Zm4.227-.647a.648.648,0,0,1-.647.647H12.085V6.008h3.624Zm1.435-8.177A.648.648,0,0,1,16.5,5.4H12.085V3.784H16.5a.648.648,0,0,1,.647.647v.326Z" transform="translate(-3.874)" fill="#fff"/></path></g></svg> '+language_data.btn_redeem+' </button>' +
        '<div class="overlay hidden"></div><div class="popup-redeem-confirm modal hidden"><div class="popup-title">'+language_data.redemption_confirm+'</div><div class="popup-redeemed-title hidden">'+language_data.redemption_success+'</div><div class="popup-text">'+ language_data.redemption_note1 +
        reward.intouchPoints + language_data.redemption_note2 +
        '</div><div class="confirm-redeem-btn-div"><button onclick="closePopup()" class="popup-cancel-btn">'+language_data.cancel +'</button><button onclick="confirmRedeemedPopup(' +
        parseInt(cus_phone) +
        "," +
        id +
        ')" class="popup-confirm-btn">'+language_data.confirm+'</button></div><div class="redeemed-btn-div hidden"><button id="use-now" class="popup-use-redeemed-btn">'+language_data.use_now+'</button><button onclick="noUseYet()" class="popup-not-use-redeemed-btn">'+language_data.use_later+'</button></div></div> </div> <div class="faq-line"><button class="faq-btn-div" onclick="faqs(0)">'+language_data.description+'</button><div class="faq-answer" style="display:none;">'+ reward.description +'</div> </div> <div class="faq-line"><button class="faq-btn-div" onclick="faqs(1)">'+language_data.term_codition+'</button><div class="faq-answer" style="display:none;">     It is a long established fact that a reader will be distracted by the readable content of a page when     looking at its layout.</div> </div></div>';
      document.getElementById("reward-detail-div").innerHTML =
        reward_detail_html;
    });
  });
}
